import React, { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import VideoCard from '../common/VideoCard.jsx';
import PropTypes from 'prop-types';
import { __ } from '../../Lang.js';

const RelatedRecommendedVideos = ({
  relatedVideos=[],
  recommendedVideos=[],
  currentPage,
  setCurrentPage,
  activeTab,
  title,
  autoplayIndex,
}) => {
  const videos = activeTab === 'recommended' ? recommendedVideos : relatedVideos;
  const [videosPerPage, setVideosPerPage] = useState(() => window.innerWidth < 768 ? 1 : 3);

useEffect(() => {
  const handleResize = () => {
    setVideosPerPage(window.innerWidth < 768 ? 1 : 3);
  };
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

const totalPages = Math.max(0, (videos?.length || 0) - videosPerPage + 1);
const visibleVideos = videos?.slice(currentPage, currentPage + videosPerPage);


  const formatTitle = (rawTitle) => {
    if (!rawTitle) return '';
    const stripped = rawTitle
      .replace(/^collection_/, '')
      .replace(/^audiobook_/, '');
    return stripped
      .split(/[_\s]+/)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <div className="related-videos-wrapper">
      <div className="related-videos-container">
        <h2 className="related-videos-title">
          {title
            ? formatTitle(title)
            : activeTab === 'related'
            ? __('Related Content') 
            : __('Recommended Content')}
        </h2>

        {videos?.length > 0 ? (
          <div className="related-videos-pagination">
            <div className="pagination-nav">
              <IconButton
                onClick={() => currentPage > 0 && setCurrentPage(currentPage - 1)}
                className="pagination-btn"
                disabled={currentPage === 0}
                sx={{ width: 30, height: 30, backgroundColor: 'white', border: '1px solid #ddd', borderRadius: '50%', p: 0 }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M15 18l-6-6 6-6" />
                </svg>
              </IconButton>

              <IconButton
                onClick={() => currentPage < totalPages - 1 && setCurrentPage(currentPage + 1)}
                className="pagination-btn"
                disabled={currentPage >= totalPages - 1}
                sx={{ width: 30, height: 30, backgroundColor: 'white', border: '1px solid #ddd', borderRadius: '50%', p: 0 }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </IconButton>
            </div>

                        <div className="related-videos-list">
        {visibleVideos.map((video, index) => {
const absoluteIndex = currentPage + index;
  const isUpNext = activeTab !== 'recommended' && absoluteIndex === autoplayIndex + 1;

  return (
    <div key={index + '-' + video.uniqid} className="related-video-card">
      {isUpNext && (
        <div className="up-next-label">{__('UP NEXT')}</div>
      )}
      <div
        className="related-video-card-link"
      >
        <VideoCard video={video} />
      </div>
    </div>
  );
})}
            </div>
          </div>
        ) : (
          <p className="no-related-videos">{__('No related content available.')}</p>
        )}
      </div>
    </div>
  );
};

RelatedRecommendedVideos.propTypes = {
  relatedVideos: PropTypes.array,
  recommendedVideos: PropTypes.array,
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired,
  title: PropTypes.string,
  autoplayIndex: PropTypes.number,
};

export default RelatedRecommendedVideos;